"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Sarah Johnson",
  role: "Lead Designer",
  bio: "Creative visionary with 10+ years crafting beautiful digital experiences.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/sarah_johnson_portrait.png",
  initials: "SJ"
}, {
  id: 2,
  name: "Michael Chen",
  role: "Senior Developer",
  bio: "Full-stack expert passionate about building scalable applications.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/michael_chen_portrait.png",
  initials: "MC"
}, {
  id: 3,
  name: "Emma Rodriguez",
  role: "Product Manager",
  bio: "Strategic thinker driving product vision and customer success.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/emma_rodriguez_portrait.png",
  initials: "ER"
}, {
  id: 4,
  name: "David Kim",
  role: "Marketing Lead",
  bio: "Growth specialist with a knack for compelling brand storytelling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/david_kim_portrait.png",
  initials: "DK"
}];
export default function OurTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section id="our-team" className="bg-background py-16 md:py-24" ref={ref}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-foreground mb-3">Our Team</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Meet the talented individuals behind our success
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className={`bg-surface border border-border hover:shadow-medium hover:-translate-y-1 transition-all duration-200 px-6 py-8 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <div className="flex flex-col items-center text-center">
                <SafeHydrate><Avatar className="w-24 h-24 mb-4 border-[1.5px] border-border">
                  <AvatarImage src={member.image} alt={member.name} />
                  <AvatarFallback className="bg-muted text-foreground text-lg font-semibold">
                    {member.initials}
                  </AvatarFallback>
                </Avatar></SafeHydrate>
                
                <h3 className="text-foreground text-xl font-semibold mb-1">
                  {member.name}
                </h3>
                
                <p className="text-muted-foreground text-sm font-medium mb-3">
                  {member.role}
                </p>
                
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {member.bio}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}